import styled from 'styled-components';
import { fontSize, fontWeight, mediaMax, primaryColor, tertiaryColor } from '@styles/utils';
import { Button } from '@styles/shared/buttons';
import FormField from '@shared/modules/form/components/FormField';
import { TextArea } from '@styles/shared/form/TextArea';
import { HttpErrorMessage } from '@shared/components/message/Message';

export const DiagnosticsContainer = styled.div``;

export const DiagnosticsContent = styled.div`
  margin: 0 auto;
  padding: 36px 0 40px 0;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 36px 16px 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const DiagnosticsContentSubtitle = styled.h2`
  padding-bottom: 40px;
  ${fontSize.h2};
  font-weight: ${fontWeight.standard};
  color: ${primaryColor(500)};

  @media screen and (${mediaMax.tablet}) {
    padding-bottom: 20px;
  }
`;

export const DiagnosticsContentErrorMessage = styled(HttpErrorMessage)`
  margin-top: 16px;
  margin-bottom: 0;
`;

export const DiagnosticsContentLabel = styled.p`
  ${fontSize.large};
  font-weight: ${fontWeight.semiBold};
  color: ${tertiaryColor(700)};

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const DiagnosticsContentText = styled.p`
  padding-top: 16px;
  ${fontSize.standard};
  font-weight: ${fontWeight.normal};
  color: ${tertiaryColor(700)};
`;

export const DiagnosticsContentRating = styled.div`
  padding-top: 24px;

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const DiagnosticsContentImageRating = styled.img`
  margin-right: 15px;
`;

export const DiagnosticsContentComment = styled(FormField)`
  padding-top: 15px;
`;

export const DiagnosticsContentTextArea = styled(TextArea)`
  min-height: 108px;
`;

export const DiagnosticsContentButtonContainer = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DiagnosticsContentImage = styled.div`
  padding-bottom: 50px;
`;

export const DiagnosticsContentButton = styled(Button)`
  width: max-content;
`;
